const VocabQualifications = {
  title: ['Título', 'Title'],
  institution: ['Institución', 'Institution'],
  category: ['Categoría', 'Category'],
  year_of_completion: ['Año de obtención', 'Year of completion'],
  license: ['Cédula / Licencia', 'License / Credential ID'],
  new_qualification: ['Nueva cualificación', 'New qualification'],
  profesional: ['Profesional', 'Professional'],
  masters: ['Maestría', 'Master\'s Degree'],
  doctorate: ['Doctorado', 'Doctorate'],
  missing_fields: ['Por favor complete los campos obligatorios', 'Please fill in all required fields'],
};

export type VocabQualificationsKey = keyof typeof VocabQualifications;
export default VocabQualifications;